import React, { Component} from "react";
import { withRouter, Redirect} from "react-router-dom";
import { clear, set, get } from "services/storage";
import { school_classes_api, school_classes_store_api, school_activities_classes_api, prof_classes_api, 
  prof_activities_classes_api, schoolStudents, schoolStudents2, missing_students_api_get, profStudents, schools_scholar_years,
  get_list_schools_sub_groups, fields_export_api_get, textbooks_subjects_export_api_get,
  school_professors_list_api, school_professors_list_api2, list_semesters_api, check_school_api, log_js_error, cities_api_get, sanady_api_post, sanady_api_get,
  get_koolskools_levels, school_settings_payment_api_get, transport_api_get, device_token_api, 
  school_mailings_api_list, school_mailings_api_store, school_email_api_list, school_email_api_store, schools_notifications_api_get, absencesApi, absences_post_api, 
  schools_documents_requests_api_get, check_group_last_update,
  behaviours_list_api, behaviours_list_api_post, reports_list_api, get_instanceID_info, sanady_professors_api,
  professor_professors_list_api, school_permissions_api_list, get_list_schools,
  school_inscriptions_api_get, check_ip_address_access, students_exemptions_from_subjects_api_post,reregistration_blocking_reasons_api_get} from "services/cms/api";
  import { listSchoolsAction, scholarYearsAction } from "services/cms/actions";
import {levelGroups} from "services/api"
import axios from "axios";
import moment from "moment";
import {messaging} from 'init_fcm'
import { connect } from "react-redux";
import Permission from 'components/Permission'
import { init_database } from "../services/database/schools";
import localforage from 'localforage';
import {get_projects_from_pogram} from "utils/utils"
import { schools_cours_validation } from "services/cms/api";



const instance = axios.create({ baseURL: process.env.REACT_APP_URL_CMS });
const base_url = process.env.REACT_APP_URL_CMS;
class LayoutSchoolSystem extends Component {
  constructor(props) {
    super(props);
    this.permissionObj = new Permission();
    this.user = get("session_user");
    this.is_admin = (this.user.profile.is_school_admin && !this.user.profile.is_assistant);
    this.school = get("school");
    this.is_assistant = this.school && this.user.profile.is_assistant;
    this.professor_school = !this.school && this.user.profile.schools[0];
    this.is_program_system = this.school && this.school.project_id || this.user && (this.user.profile.is_program_system || this.user.profile.is_sanady_assistant);
    this.program = get("program");
    this.levels = get('levels') || [];
    this.koolskools_levels = get('koolskools_levels') || [];
    this.school_levels_for_assistant = get('school_levels_for_assistant') || [];
    this.is_sanady_view = this.school && this.school.project_id || this.user && (this.user.profile.is_program_system || this.user.profile.is_sanady_assistant);
    this.ws = false
    var school_ws = ""; 
    // window.old_api = true;
    this.show_students_to_change_levels_notifs = (this.user.profile.is_program_system || this.user.profile.is_sanadi_coordinator);
    var school_administrators_ws = ""; 
    this.permission = new Permission();
    this.permission.setCurrentSection('reporting');
    Array.prototype.unique = function() {
      var a = this.concat();
      for(var i=0; i<a.length; ++i) {
          for(var j=i+1; j<a.length; ++j) {
              if(a[i].id === a[j].id)
                  a.splice(j--, 1);
          }
      }
      return a;
    }; 
    Array.prototype.unique_classe_ids = function() {
      var a = this.concat();
      for(var i=0; i<a.length; ++i) {
          for(var j=i+1; j<a.length; ++j) {
              if(a[i].classe_id === a[j].classe_id)
                  a.splice(j--, 1);
          }
      }
      return a;
    }; 
    Array.prototype.unique_item = function() {
      var a = this.concat();
      for(var i=0; i<a.length; ++i) {
          for(var j=i+1; j<a.length; ++j) {
              if(a[i] === a[j])
                  a.splice(j--, 1);
          }
      }
      return a;
    }; 
    // if(props.match.params.school_id && !this.user.profile.is_formator){
    //   school_ws = `&school_id=${props.match.params.school_id}`;
    //   if(this.school && this.school.administrators_usernames && this.school.user_can_view_admin_conversations && this.school.administrators_usernames.indexOf(this.user.profile.username) == -1){
    //     school_administrators_ws = `&administrators_usernames=${this.school.administrators_usernames}`;
    //   }
    // }
    
    if(/*this.permission.can('ca_table') && */!this.user.profile.is_formator && (!this.school || !this.school.is_parent)){
      if(this.school && !global.ws_notification){
        global.ws_notification = new WebSocket(
          `${process.env.REACT_APP_URL_MESSAGING}/ws/users/?user_id=${this.user.profile.user_id}&group_id=${this.school.group_id}`
        );
      }
    }

    // this.ws_notifier = new WebSocket(
    //   `${process.env.REACT_APP_URL_WS_CMS}/ws/notifications/?username=${
    //       this.user.profile.username
    //   }${school_ws}${school_administrators_ws}`
    // );


    if(!this.user.profile.is_formator){
      get_koolskools_levels(this.school ? {school_id: this.school.id} : {}).then(levels_ => {
        if(this.user && (this.user.is_tarl_professor || (this.user.profile.is_program_system || this.user.profile.is_sanady_assistant))){
          this.koolskools_levels = get('koolskools_levels') || [];
          this.levels = get('levels') || [];
          let {programs_projects_schools_classes_by_years} = this.state;
          let programs_projects_schools_classes_by_years_ = {};
          Object.keys(programs_projects_schools_classes_by_years || {}).map(scholar_year_id => {
            let programs_projects_schools_classes = {};
            Object.keys(programs_projects_schools_classes_by_years[scholar_year_id]).map(classe_id => {
              let classe_ = programs_projects_schools_classes_by_years[scholar_year_id][classe_id];
              classe_.level = classe_.level || this.levels.filter(lvl => lvl.level_id == classe_.level_id)[0] || this.koolskools_levels.filter(lvl => lvl.level_id == classe_.level_id)[0];
              programs_projects_schools_classes[classe_id] = classe_;
            });
            programs_projects_schools_classes_by_years_[scholar_year_id] = programs_projects_schools_classes;
          });
          this.setState({
            programs_projects_schools_classes_by_years: programs_projects_schools_classes_by_years_,
          });
        }
      });
    }
    if(!get("level_groups") || this.user && (this.user.is_tarl_professor || (this.user.profile.is_program_system || this.user.profile.is_sanady_assistant)) && (get("level_groups").filter(lg => lg.id == 5).length == 0 || (get("other_level_groups") || []).filter(lg => lg.id == 1).length == 0)){
      levelGroups()
    }
    else if(!(this.user && (this.user.is_tarl_professor || (this.user.profile.is_program_system || this.user.profile.is_sanady_assistant))) && (get("level_groups") || []).filter(lg => lg.id == 5).length > 0){
      levelGroups()
    }
    else if((get("level_groups") || []).length == 0){
      levelGroups()
    }
    else{
      var levels_groups = get("level_groups") || [];
      var other_level_groups = get("other_level_groups") || [];
      if(this.user && (this.user.is_tarl_professor || (this.user.profile.is_program_system || this.user.profile.is_sanady_assistant))){
        let tarl_cycle = undefined;
        levels_groups = levels_groups.map(lg => {
          if(lg.is_tarl){
            lg.name = "Primaire";
            tarl_cycle = lg;
          }
          if(other_level_groups.length == 0 && lg.id == 1){
            other_level_groups.push(lg);
          }
          return lg;
        }).filter(lg => lg.num > "1" && !lg.is_tarl);
        if(tarl_cycle){
          levels_groups.unshift(tarl_cycle);
        }
      }
      else{
        levels_groups = levels_groups.filter(lg => !lg.is_tarl);
      }
      set("level_groups", levels_groups);
      set("other_level_groups", other_level_groups);
    }
    if((get('scholar_years') || []).length == 0){
      this.props
      .dispatch(scholarYearsAction())
      .then(data => {
        const years = data.payload.years;
        set("scholar_years", years);
      })
      .catch(error => console.log("errors", error));
    }
    if(this.school){
      school_permissions_api_list({schools_ids: this.school.id + "", action: "get_specific_permissions", section: "professors", ability: "update_level_classe_for_all_cycles"}, true).then(res => {
        this.can_update_level_classe_for_all_cycles = ((((res.schools_permissions || {})[this.school.id] || [])[0] || {}).abilities || []).length > 0;
      });
    }
    this.professors_last_update =  new Date().toISOString();
    this.schools_documents_requests_last_update =  new Date().toISOString();
    this.schools_documents_requests_update_last_update =  new Date().toISOString();
    this.professor_fetched = false;
    this.professors__ = [];
    this.state = {
      menuGlobal: false,
      data_loaded:false,
      classes: [],
      classes_groupes: [],
      assistant_other_classes: [],
      activities_classes: [],
      students: [],
      professors: [],
      seances:[],
      parents: [],
      semesters: [],
      cities: {},
      school_all_fields_export: {},
      school_predefined_fields_export: {},
      school_all_subjects_export: {},
      school_id: props.match.params.school_id,
      scholar_year_id: props.match.params.scholar_year_id,
      classe_id: props.match.params.classe_id,
      activity_classe_id: props.match.params.activity_classe_id,
      scholar_years: [],
      showExistantsButton: false,
      ws: this.ws,
      is_closed_payments: false,
      vehicules_need_oil_change_ids: [],
      absent_professors_today_ids: [],
      new_registred_professors_ids: [],
      students_to_change_levels_ids: [],
      missing_students: [],
      messages_notif_ids: [],
      emails_notif_ids: [],
      valid_messages_notif_ids: [],
      valid_emails_notif_ids: [],
      absences_notifications_ids: [],
      incidents_notifications_ids: [],
      leads_notifications_ids: [],
      rdv_reports_notifications_ids: [],
      documents_requests_not_dones_ids: [],
      exit_authorisations_not_dones_ids: [],
      students_notifications_ids: [],
      programs_projects_schools: {},
      programs_projects_schools_by_years: {},
      programs_projects_schools_classes_by_years: {},
      programs_regions: {},
      programs_zones: {},
      programs_companies: {},
      currentIP: "",
      students_exemptions_from_subjects: {},
      reregistration_blocking_reasons: [],
      schools_notifications: [],
      documentsRequestsRefreshKey: 0,
    };
    // if(global.authorized_access)
    this.check_current_ip();
    this.useIPChangeListener()


    window.addEventListener('store_levels',(e) => {
      this.levels = get("levels") || [];
      this.school_levels_for_assistant = get('school_levels_for_assistant') || [];
      if(this.state.professors.length == 0){
        this.professor_fetched = true;
        this.sync_professors(false);
      }
      else
        this.update_professors();
    }, false);

    if(this.school){
      this.getSchoolAbsNotifs(props.match.params.school_id, props.match.params.scholar_year_id);
      this.getSchoolIncidentsNotifs(props.match.params.school_id, props.match.params.scholar_year_id);
      this.getSchoolRDVReportsNotifs(props.match.params.school_id, props.match.params.scholar_year_id);
      this.getSchoolDocumentsRequestsNotifs(props.match.params.school_id, props.match.params.scholar_year_id);
      this.getSchoolConfig(this.school)
      if(this.school.imported_prospects_format == "format_2"){
        this.getLeadsNotifs(props.match.params.school_id, props.match.params.scholar_year_id);
      }
    }

    if(props.school_account){
      if(!this.user || !this.user.profile.is_school_admin) 
        return <Redirect to="/home/school" />;
      if(/([À-ú]|\s)/.test(this.user.profile.username)){
        var lev = get("level_groups");
        var current_language = get("current_language");
        clear();
        localforage.clear();
        if(global.ws_notification)
          global.ws_notification.close();
        set("level_groups", lev);
        set("current_language", current_language);
        return <Redirect to="/home/school" />;
      }
      if((this.user.profile.is_program_system || this.user.profile.is_sanady_assistant) && !get('project')){
        if(this.props.path != "/school/program/list")
          return <Redirect to="/school/program/list" />;
      }
        
        
      else if(this.props.path != "/school/list" && !(this.user.profile.is_program_system || this.user.profile.is_sanady_assistant)){
        if(this.user.profile.admin_schools && this.user.profile.admin_schools.filter(sc => sc.id == parseInt(this.props.computedMatch.params.school_id)).length == 0)
          return <Redirect to="/school/list" />;
        check_school_api({school: this.props.computedMatch.params.school_id}).then(res => {
          // school_permissions_api_list({school_id: this.props.computedMatch.params.school_id});
        }).catch(err => {
          this.props.history.push("/school/list")
        })
      }
    }
    else{
      if(!this.user || ['pr','pr_pa'].indexOf(this.user.account_type) < 0  || ((this.user.schools || this.user.profile && this.user.profile.schools || []).length == 0 && !(this.user.profile && this.user.profile.had_sanady_school_from_last_year)))
        return <Redirect to="/home/professor" />;
      if(/([À-ú]|\s)/.test(this.user.profile.username)){
        var lev = get("level_groups");
        var current_language = get("current_language");
        clear();
        localforage.clear();
        if(global.ws_notification)
          global.ws_notification.close();
        set("level_groups", lev);
        set("current_language", current_language);
        return <Redirect to="/home/professor" />;
      }
    }
    if(this.is_program_system && this.program){
      this.getProgramsProjectsSchools();
      this.handleGetRegions();
      this.handleGetZones();
      this.handleGetCompanies();
    }
    this.get_schools_notifications();
  }

  get_schools_notifications = () => {
    let data = {action: "get_schools_notifications"};
    if(this.school){
      data.school_id = this.school.id;
    }
    return schools_notifications_api_get(data).then(res => {
      this.setState({
        schools_notifications: res.schools_notifications || [],
      });
    })
      .catch(err => {
        console.log(err);
      });
  }
  mark_school_notification_as_read = (notificationId) => {
    let data = {school_notification_id: notificationId, action: "mark_as_seen"};
    if(this.school){
      data.school_id = this.school.id;
    }
    return schools_notifications_api_get(data).then(res => {
      if(res.success){
        this.setState({
          schools_notifications: this.state.schools_notifications.map(n => {
            if(n.id == notificationId){
              n.seen = true;
            }
            return n;
          }),
        });
      }
    })
      .catch(err => {
        console.log(err);
      });
  }

  getSchoolConfig = school => {
      var data={
        action: "get_school_config",
        school_id: school.id,
      }
      schools_cours_validation(data).then(res=>{
        this.school = {...this.school, ...(res.school_config || {})}
        set("school", this.school);
      });
    }

  check_current_ip = async () => {
    try {
      const response = await fetch("https://checkip.amazonaws.com");
      const ip = await response.text();
      // const data = await res.json();
      const newIP = ip.trim();
      if (this.state.currentIP !== newIP) {
        console.log("L'adresse IP a changé :", newIP);
        this.check_ip_address_access(); // Déclenche l'événement
        this.setState({
          currentIP: newIP
        })
      }
    } catch (error) {
      console.error("Erreur lors de la récupération de l'IP :", error);
    }
  }
  useIPChangeListener = () => {
    if(this.school && this.school.ip_address && this.user.profile.is_assistant){
      this.ip_interval = setInterval(async () => {
        this.check_current_ip()
      }, 5000)
    }
  }

  check_ip_address_access = () => {
    if(this.school && this.school.ip_address && this.user.profile.is_assistant){
      let data = {
        school_id: this.school.id
      }
      check_ip_address_access(data).then(res => {
        if(!res.authorized){
          // global.authorized_access = false;
          this.props.history.push('/NotAuthorized');
        }

        // this.setState({ip_address_authorized: res.authorized})
      })
    }
  }

  getProgramsProjectsSchoolsClasses = (schools_ids, scholar_year_id) => {
    var data = {
      action: "get_programs_projects_schools_classes",
      schools_ids_str: schools_ids.join(","),
    };
    data.scholar_year_id = scholar_year_id || this.props.match.params.scholar_year_id;
    sanady_api_post(data).then(res => {
      this.levels = get('levels') || [];
      if(res.success){
        let {programs_projects_schools_classes_by_years} = this.state;
        let programs_projects_schools_classes = {};

        let all_projects = get_projects_from_pogram({}, true, this.state.programs_projects_schools_by_years[data.scholar_year_id] || {})
        let all_schools = [];
        all_projects.map(pr => {
          all_schools = all_schools.concat(pr.schools || []);
        });
        this.all_schools_ids = all_schools.map(s => s.id);
        Object.keys(res.programs_projects_schools_classes || {}).map(classe_id => {
          let classe_ = res.programs_projects_schools_classes[classe_id];
          classe_.level = this.levels.filter(lvl => lvl.level_id == classe_.level_id)[0] || this.koolskools_levels.filter(lvl => lvl.level_id == classe_.level_id)[0];
          classe_.school_obj = all_schools.filter(sc => sc.id == classe_.school)[0];
          programs_projects_schools_classes[classe_id] = classe_;
        });
        programs_projects_schools_classes_by_years[data.scholar_year_id] = programs_projects_schools_classes;
        this.setState({
          programs_projects_schools_classes_by_years: programs_projects_schools_classes_by_years,
        });
      }

    }).catch(err => {
      console.log(err);
    })
  }

  add_project_to_schools = programs_projects_schools => {
    let programs_keys = Object.keys(programs_projects_schools || {});
    programs_keys.map(pk_ => {
      let program = programs_projects_schools[pk_];
      let projects_keys = Object.keys(program.projects || {});
      let projects_list = [];
      projects_keys.map(pk => {
        let project = program.projects[pk];
        project.program = program;
        project.schools = project.schools.map(sc => {
          sc.project_id = project.id;
          sc.project = project;
          
          return sc;
        });
        projects_list.push(project);
      });
      projects_list.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
      program.projects_list = projects_list;
    });
    return programs_projects_schools;
  }

  getProgramsProjectsSchools = (other_scholar_year_id) => {
    var data = {
      action: "get_programs_projects_schools",
    };
    data.scholar_year_id = other_scholar_year_id || this.props.match.params.scholar_year_id;
    sanady_api_get(data).then(res => {
      let programs_regions = this.state.programs_regions || [];
      if(res.success){
        let {programs_projects_schools_classes_by_years} = this.state;
        if(res.schools_ids){
          let this_ = this;
          setTimeout(() => {
            this_.getProgramsProjectsSchoolsClasses(res.schools_ids, data.scholar_year_id);
          }, 1000);
        }
        let {programs_projects_schools_by_years, programs_projects_schools} = this.state;
        let programs_projects_schools_ = this.add_project_to_schools(res.programs_projects_schools || {})
        Object.keys(programs_projects_schools_).map(pps_key => {
          if(pps_key !== "programs"){
            let pps = programs_projects_schools_[pps_key];
            Object.keys(pps.projects).map(pr_key => {
              let pr = pps.projects[pr_key];
              pr.region = pr.region || ((programs_regions[pr.program_id] || []).filter(r => r.id == pr.project_region_id)[0] || {}).name;
              return pr;
            })
          }
        })
        if(other_scholar_year_id){
          programs_projects_schools_by_years[other_scholar_year_id] = programs_projects_schools_;
        }
        else if(this.props.match.params.scholar_year_id){
          programs_projects_schools = programs_projects_schools_;
          programs_projects_schools_by_years[this.props.match.params.scholar_year_id] = programs_projects_schools_;
        }
        if(this.user && (this.user.is_tarl_professor || (this.user.profile.is_program_system || this.user.profile.is_sanady_assistant))){
          let programs_projects_schools_classes_by_years_ = {};
          let all_projects = get_projects_from_pogram({}, true, programs_projects_schools_by_years[other_scholar_year_id || this.props.match.params.scholar_year_id] || {})
          let all_schools = [];
          all_projects.map(pr => {
            all_schools = all_schools.concat(pr.schools || []);
          });
          this.all_schools_ids = all_schools.map(s => s.id);
          Object.keys(programs_projects_schools_classes_by_years || {}).map(scholar_year_id => {
            let programs_projects_schools_classes = {};
            Object.keys(programs_projects_schools_classes_by_years[scholar_year_id]).map(classe_id => {
              let classe_ = programs_projects_schools_classes_by_years[scholar_year_id][classe_id];
              classe_.school_obj = all_schools.filter(sc => sc.id == classe_.school)[0];
              programs_projects_schools_classes[classe_id] = classe_;
            });
            programs_projects_schools_classes_by_years_[scholar_year_id] = programs_projects_schools_classes;
          });
          programs_projects_schools_classes_by_years = programs_projects_schools_classes_by_years_;
        }
        this.setState({
          programs_projects_schools: programs_projects_schools,
          programs_projects_schools_by_years: programs_projects_schools_by_years,
          programs_projects_schools_classes_by_years: programs_projects_schools_classes_by_years,
        });
      }

    }).catch(err => {
      console.log(err);
    })
  }

  handleGetRegions = () => {
    var data = {
      action: "get_regions",
    };
    sanady_api_get(data).then(res => {
      let programs_regions = res.programs_regions || [];
      var {programs_projects_schools, programs_projects_schools_by_years,} = this.state;
      Object.keys(programs_projects_schools).map(prg_key => {
        if(prg_key != "programs"){
          let pps = programs_projects_schools[prg_key];
          Object.keys(pps.projects).map(pr_key => {
            let pr = pps.projects[pr_key];
            pr.region = pr.region || ((programs_regions[pr.program_id] || []).filter(r => r.id == pr.project_region_id)[0] || {}).name;
            return pr;
          })
        }
      })
      Object.keys(programs_projects_schools_by_years).map(syi => {
        Object.keys(programs_projects_schools_by_years[syi]).map(prg_key => {
          if(prg_key != "programs"){
            let pps = programs_projects_schools_by_years[syi][prg_key];
            Object.keys(pps.projects).map(pr_key => {
              let pr = pps.projects[pr_key];
              pr.region = pr.region || ((programs_regions[pr.program_id] || []).filter(r => r.id == pr.project_region_id)[0] || {}).name;
              return pr;
            })
          }
        })
      })
      this.setState({
        programs_regions: programs_regions, 
        programs_projects_schools: programs_projects_schools, 
        programs_projects_schools_by_years: programs_projects_schools_by_years, 
      });
    });

  }
  handleGetZones = () => {
    var data = {
      action: "get_zones",
    };
    sanady_api_get(data).then(res => {
      this.setState({
        programs_zones: res.programs_zones || {},
      });
    });

  }
  handleGetCompanies = () => {
    var data = {
      action: "get_companies",
    };
    sanady_api_get(data).then(res => {
      this.setState({
        programs_companies: res.programs_companies || {},
      });
    });

  }

  componentWillReceiveProps(props){
    this.setState({
      school_id: props.match.params.school_id,
      scholar_year_id: props.match.params.scholar_year_id,
      classe_id: props.match.params.classe_id,
      activity_classe_id: props.match.params.activity_classe_id,
    })
  }

  getSchoolAbsNotifs = (school_id, scholar_year_id) => {
    var data = {
      "action": "get_absences_notifications_count",
      "school_id": school_id || this.state.school_id,
      "scholar_year": scholar_year_id || this.state.scholar_year_id,
    };
    absencesApi(data).then(res => {
      this.setState({
        absences_notifications_ids: res.absences_notifications_ids,
      });
    });
  }
  getSchoolIncidentsNotifs = (school_id, scholar_year_id) => {
    var data = {
      "action": "get_incidents_notifications_count",
      "school_id": school_id || this.state.school_id,
      "scholar_year": scholar_year_id || this.state.scholar_year_id,
    };
    behaviours_list_api(data).then(res => {
      this.setState({
        incidents_notifications_ids: res.incidents_notifications_ids,
        students_notifications_ids: this.state.students_notifications_ids.concat(res.incidents_notifications_ids).unique_item(),
      });
    });
  }
  getLeadsNotifs = (school_id, scholar_year_id) => {
    var data = {
      action: "get_inscriptions",
      action2: "get_leads_notifications_ids",
      school_filter: "",
      school_id: school_id || this.state.school_id,
      scholar_year: scholar_year_id || this.state.scholar_year_id,
      only_confirmed: false,
      get_imported: true,
    };
    if(this.is_admin || this.permissionObj.has_ability("inscriptions", "view_all_imported_prospects")){
      data.view_all_imported_prospects = "true";
    }
    school_inscriptions_api_get(data).then(res=> {
      this.setState({
        leads_notifications_ids: res.leads_notifications_ids,
      });
    }).catch(err => {console.log(err)});
  }
  getSchoolRDVReportsNotifs = (school_id, scholar_year_id) => {
    var data = {
      "action": "get_rdv_reports_notifications_count",
      "school_id": school_id || this.state.school_id,
      "scholar_year": scholar_year_id || this.state.scholar_year_id,
    };
    reports_list_api(data).then(res => {
      this.setState({
        rdv_reports_notifications_ids: res.rdv_reports_notifications_ids,
        students_notifications_ids: this.state.students_notifications_ids.concat(res.rdv_reports_notifications_ids).unique_item(),
      });
    });
  }
  getSchoolDocumentsRequestsNotifs = (school_id, scholar_year_id) => {
    var data = {
      "action": "get_documents_requests_not_dones_ids",
      "school_id": school_id || this.state.school_id,
      "scholar_year": scholar_year_id || this.state.scholar_year_id,
      type_requests: "new_requests",
      from_school: true,
    };
    if(!window.old_api && this.is_assistant){
      data.is_assistant = true;
    }
    schools_documents_requests_api_get(data).then(res => {
      this.setState({
        documents_requests_not_dones_ids: res.documents_requests_ids,
        exit_authorisations_not_dones_ids: res.exit_authorization_requests_ids || [],
      });
    });
  }

  componentDidCatch(error, info) {
    // console.log(error)
    // console.log(error.stack)
    // Display fallback UI
    this.props.history.push('/ErrorPage');
    // You can also log the error to an error reporting service
    var data={
      // error_msg: error.message,
      error_stack: error.stack,
      // error_info: info.componentStack
    }
    log_js_error(data);
  }

  get_local_levels = () => {
    this.levels = get('levels') || [];
    return this.school_levels_for_assistant.length > 0 ? this.school_levels_for_assistant.filter(l => this.levels.filter(l_ => l_.level_id == l.level_id)[0] || l) : this.levels;
  }

  componentDidMount(){
    this.school = get("school");
    this.schools = this.user.profile.admin_schools.filter(sc => (this.school && this.school.is_parent) || !sc.is_parent);
    if((this.permission.can('ca_table') || this.permission.can('unpaid_list') || this.permission.can('unpaid_list_without_amount')) && this.schools.length > 0){
      global.loading_data = false;
      if(this.user.profile.is_assistant)
        school_permissions_api_list({schools_ids: this.schools.map(s => s.id).join(";;"), action: "payments_permissions"}, true).then(res => {
          let schools_permission_reporting_ids = Object.keys(res.schools_permissions).filter(sc_key => res.schools_permissions[sc_key].findIndex(sp => sp.section.name == "reporting" && sp.abilities.findIndex(ab => ab.name == 'ca_table' || ab.name == 'unpaid_list' || ab.name == 'unpaid_list_without_amount') >= 0) >=0).map(sc_key => parseInt(sc_key));
          if(schools_permission_reporting_ids.length > 0)
            init_database(this.schools.filter(sc => schools_permission_reporting_ids.indexOf(sc.id) >= 0), true);
        });
      else
        init_database(this.schools, true, this.school && this.school.id);
    }

    if(!this.user.profile.is_formator && (!this.school || !this.school.is_parent)){
      this.getJournals();
      if(this.school && this.can_update_level_classe_for_all_cycles !== false && this.can_update_level_classe_for_all_cycles != true){
        school_permissions_api_list({schools_ids: this.school.id + "", action: "get_specific_permissions", section: "professors", ability: "update_level_classe_for_all_cycles"}, true).then(res => {
          this.can_update_level_classe_for_all_cycles = ((((res.schools_permissions || {})[this.school.id] || [])[0] || {}).abilities || []).length > 0;
          this.getClassesList();
        });
      }
      else{
        this.getClassesList();
      }
      this.getStudentsList();
      this.getAbsentProfessorsTodayIdsList();
      // this.getProfessorsList();
      this.getActivitiesClassesList();
      this.getVehiculesNeedOilChangeCount();
      this.getNotifMail();
      // this.getNotifEmail();
      if(this.state.school_id)
        this.getScholarYears();
      if(this.school && this.school.enable_mailing_validation)
        this.getNotifValidMail();
      // if(this.school && this.school.enable_email_validation)
      //   this.getNotifValidEmail();
    }
    if(this.is_sanady_view){
      this.getNewRegisteredProfessorsIdsList();
      if(this.show_students_to_change_levels_notifs){
        this.refreshStudentsToChangeLevels();
      }
      this.refreshStudentsMissings();
    }
    if(this.school && this.school.is_parent){
      if(this.can_update_level_classe_for_all_cycles !== false && this.can_update_level_classe_for_all_cycles != true){
        school_permissions_api_list({schools_ids: this.school.id + "", action: "get_specific_permissions", section: "professors", ability: "update_level_classe_for_all_cycles"}, true).then(res => {
          this.can_update_level_classe_for_all_cycles = ((((res.schools_permissions || {})[this.school.id] || [])[0] || {}).abilities || []).length > 0;
          this.getClassesList();
        });
      }
      else{
        this.getClassesList();
      }
      this.getSubGroupsList();
    }
    if(this.school){
      this.get_schools_students_stats();
      var data = {
        action: "get_semesters",
        school_id: this.state.school_id
      };
      list_semesters_api(data).then(res => {
        this.setState({
          semesters: res.semesters
        })
      })
      data = {
        action: "get_all_school_fields_export",
        school_id: this.state.school_id
      };
      fields_export_api_get(data).then(res => {
        this.setState({
          school_predefined_fields_export: res.school_predefined_fields_export || {},
          school_all_fields_export: res.school_all_fields_export || {}
        })
      })
      data = {
        action: "get_all_school_subjects_export",
        school_id: this.state.school_id
      };
      textbooks_subjects_export_api_get(data).then(res => {
        this.setState({
          school_all_subjects_export: res.school_all_subjects_export || {}
        })
      })
    }
    else{
      if(this.professor_school){
        var data = {
          action: "get_all_school_fields_export",
          school_id: this.professor_school.id,
          is_professor: true,
        };
        fields_export_api_get(data).then(res => {
          this.setState({
            school_predefined_fields_export: res.school_predefined_fields_export || {},
            school_all_fields_export: res.school_all_fields_export || {}
          })
        })
      }
      try{
        this.refreshProfessorSchools()
      }
      catch(err){

      }
    }
    window.addEventListener('new_notification',(e) => {
      debugger
    }, false);
    if(messaging && !get('device_token')){
      messaging
      .requestPermission()
      .then(async () => {
        const token = await messaging.getToken();
        set('device_token', token);
        this.refresh_token(token)
      })
    }
      
      // this.refreshStats({selected_period:0,selected_subject:''});
    this.getStudentsExemptionsFromSubjects();
    this.handleGetCities()
    if(this.school){
      this.get_reregistration_blocking_reasons();
    }
  }
  get_reregistration_blocking_reasons = () => {
    var data = {
        action: "get_reregistration_blocking_reasons",
    };
    data.school_id = this.school.id;

    reregistration_blocking_reasons_api_get(data).then(res => {
      this.setState({
        reregistration_blocking_reasons: res.reregistration_blocking_reasons || [],
      });
    });
  }
  refreshProfessorSchools = () => {
    var data = {
        action: "refresh_professor_schools",
        schools_ids: this.user.profile.schools.map(s => s.id),
    };
    profStudents(data).then(res=> {
        this.user.profile.schools = this.user.profile.schools.map(sc => {
          let refreshes_sc = (res.professor_schools || []).filter(sc_ => sc_.id == sc.id)[0]
          return refreshes_sc || sc;
        })
        set("session_user", this.user);
        var event = document.createEvent('Event');

        // Nomme l'événement 'build'.
        event.initEvent('refres_schools', true, true);
        window.dispatchEvent(event)
    });
  }

  handleGetCities = () => {
    var data = {
      action: "get_cities",
      school_id: this.state.school_id
    };
    cities_api_get(data).then(res => {
      this.setState({
        cities: res.cities || {},
      });
    });

  }


  componentWillMount() {
    window.addEventListener('refresh_students_stats',(e) => {
      this.get_schools_students_stats(true);
    }, false);
  }

  componentWillUnmount(){
      window.removeEventListener('refresh_students_stats',() => {}, false);
      clearInterval(this.ip_interval)
      clearInterval(this.sync_professors_interval)
  }

  get_schools_students_stats = (trigger_event) => {
    if(!trigger_event && this.school.students_stats && this.school.students_stats.nbr_deactivated_students !== undefined){
      return;
    }
    var data = {
      action: "get_schools_students_stats",
      action2: "get_deactivated_students_stats",
      scholar_year_id: this.state.scholar_year_id,
      schools_ids_str: "(" + this.school.id + ")",
    };
    get_list_schools(data).then(res => {
      this.school.students_stats = res.schools_students_stats[this.school.id];
      this.school.professors_classes_stats = res.schools_professors_stats.hasOwnProperty(this.school.id)?res.schools_professors_stats[this.school.id]:{nbr_professors: 0};
      set("school", this.school);
      if(trigger_event){
        var event = document.createEvent('Event');
        event.initEvent('students_stats_updated', true, true);
        window.dispatchEvent(event);
      }
    })
  }

  refresh_token = token => {
    var data = {
      device_token: token
    };
    device_token_api(data)
  }

  getVehiculesNeedOilChangeCount = () => {
    transport_api_get({
      school_id: this.state.school_id,
      action: "get_vehicules_need_oil_change_ids",
    }).then(res => {
      this.setState({
        vehicules_need_oil_change_ids: res.vehicules_need_oil_change_ids || []
      });
    })
  }
  getSubGroupsList = () => {
    get_list_schools_sub_groups({
      school: this.state.school_id
    }).then(res => {
      this.setState({
        sub_groups: res.sub_groups.filter(sg => !this.user.profile.is_assistant || sg.schools.filter(sc => sc.checked).length > 0).map(sg => {
          if(this.user.profile.is_assistant)
            sg.schools = sg.schools.filter(sc => sc.checked)
          return sg
        })
      });
    })
  }

  getScholarYears = () => {
    schools_scholar_years({
      scholar_years_only: true
    }).then(res => {
      var current_year = res.years.filter(y => y.id == this.state.scholar_year_id)[0],
        showExistantsButton = false;
      if(current_year && (current_year.next || (res.years.filter(y => y.previous).length > 0 && current_year.current)))
        showExistantsButton = true;
      
      
      this.setState({
        scholar_years: res.years,
        showExistantsButton: showExistantsButton
      }, () => {
        if(res.years && this.is_program_system && this.program){
          res.years.map(year => {
            if(year.id != this.props.match.params.scholar_year_id){
              this.getProgramsProjectsSchools(year.id);
            }
          })
        }
      });
    })
  }

  getClassesList = () => {
    var {school_id, scholar_year_id, classes} = this.state,
        pat = /^https?:\/\//i;
    var existing_classes_levels_ids = {};
    this.existing_classes_levels_ids = {};
    if (school_id) {
      var data = {
        action: "get_classes",
        school_id: school_id,
        scholar_year: scholar_year_id
      };
      school_classes_api(data).then(res => {
        let classes_ids_ = [];
        this.setState({
          classes: res.classes.map(c => {
            if(!existing_classes_levels_ids[c.level && c.level.level_id || c.level_id]){
              existing_classes_levels_ids[c.level && c.level.level_id || c.level_id] = true;
            }
            c.full_image_url = (pat.test(c.full_image_url) || !c.full_image_url)?c.full_image_url:base_url + "/" +  c.full_image_url;
            classes_ids_.push(c.classe_id);
            return c;
          })
        }, () => {
          this.existing_classes_levels_ids = existing_classes_levels_ids;
          if(!this.professor_fetched)
            this.sync_professors(Object.keys(existing_classes_levels_ids))
          else
            this.update_professors()
          if(this.sync_professors_interval)
            clearInterval(this.sync_professors_interval)
          this.sync_professors_interval = setInterval(() => {
            this.sync_professors(Object.keys(existing_classes_levels_ids))
          }, 30000) // 30 sec
          // this.getProfessorsList(Object.keys(existing_classes_levels_ids))
          data = {
            action: "get_classes_groupes",
            school_id: school_id,
            scholar_year: scholar_year_id,
            classes_ids: classes_ids_.join(","),
          };
          school_classes_store_api(data).then(res => {
            this.setState({
              classes_groupes: res.classes_groupes || [],
              classes: this.state.classes.map(c => {
                c.classe_groupes = (res.classes_groupes || []).filter(cg => cg.classe_id == c.classe_id);
                return c;
              })
            });
          })
        });
      });
    } else {
      prof_classes_api({device_token: get('device_token')}).then(classes=> {
        this.setState({
          classes: (classes || []).map(cl => {
            cl.full_name = cl.full_name || (cl.level ? (cl.level.name + " " + cl.name) : cl.name);
            return cl;
          })
        }, () => {
          if(!this.professor_fetched)
            this.sync_professors(Object.keys(existing_classes_levels_ids))
          else
            this.update_professors()

          if(this.sync_professors_interval)
            clearInterval(this.sync_professors_interval)
          this.sync_professors_interval = setInterval(() => {
            this.sync_professors(Object.keys(existing_classes_levels_ids))
          }, 30000) // 30 sec
        });
        // get_instanceID_info(fcmToken).then(res => {
        //   storage.set('topics', JSON.stringify(res.rel.topics));
        // });
        // get_instanceID_info().then(res => {
        //   console.log(res)
        //   if(res.rel)
        //     set('topics', res.rel.topics);
        // });
      });
    }
  }

  refreshGlobalProfessors = ( professors_, classe_id, activity_classe_id) => {
    var {classes, professors, activities_classes} = this.state;
    professors_.map(pr => {
      professors = professors.map(p => {
        if(p.id == (pr.id || pr.school_professor_relationship_id)){
          if(classe_id){
            if(p.classes_ids){
              p.classes_ids = (pr.classes_ids || []).concat([classe_id]).unique_item();
            }
            p.classes = (p.classes || []).concat(classes.filter(cl => cl.classe_id == classe_id)).unique_classe_ids();
          }
          if(activity_classe_id){
            if(p.activities_classes_ids){
              p.activities_classes_ids = (pr.activities_classes_ids || []).concat([activity_classe_id]).unique_item();
            }
            p.activities_classes = (p.activities_classes || []).concat(activities_classes.filter(ac => ac.id == activity_classe_id)).unique();
          }
        }
        return p;
      });

    })
    this.setState({professors: professors});
  }
  getActivitiesClassesList = () => {
    var {school_id, scholar_year_id, activities_classes} = this.state,
        pat = /^https?:\/\//i;
    if (school_id) {
      var data = {
        action: "get_activities_classes",
        school_id: school_id,
        scholar_year: scholar_year_id
      };
      school_activities_classes_api(data).then(res => {
        this.setState({
          activities_classes:res.activities_classes.map(c => {
            c.full_image_url = (pat.test(c.full_image_url) || !c.full_image_url)?c.full_image_url:base_url + "/" +  c.full_image_url;
            return c;
          })
        }, this.update_professors);
      });
    } else {
      prof_activities_classes_api({}).then(activities_classes=> {
        this.setState({
          activities_classes: activities_classes
        }, this.update_professors);
      });
    }
  }

  getStudentsExemptionsFromSubjects = () => {
    var data={
      action: "get_all_students_exemptions_from_subjects",
      scholar_year_id: this.state.scholar_year_id,
      schools_ids: this.state.school_id ? this.user.profile.admin_schools.map(s => s.id).join(",") : this.user.profile.schools.map(s => s.id).join(","),
    }
    students_exemptions_from_subjects_api_post(data).then(res=> {
        this.setState({
          students_exemptions_from_subjects: res.students_exemptions_from_subjects || {},
        });
    });
  }
  updateStudentsExemptionsFromSubjects = (school_user_id, exemptions_from_subjects) => {
    if(!this.state.students_exemptions_from_subjects[school_user_id]){
      this.state.students_exemptions_from_subjects[school_user_id] = {};
    }
    this.state.students_exemptions_from_subjects[school_user_id][this.state.scholar_year_id] = exemptions_from_subjects;
    this.setState({students_exemptions_from_subjects: this.state.students_exemptions_from_subjects})
  }

  correctStudentsInfo = (students, fields) => {
    if(Object.keys(global.all_students || {}).length == 0){
      return students;
    }
    return students.map(student => {
      let std = global.all_students[student.user_id];
      if(!std){
        return student;
      }
      fields.forEach(field => {
        if(std[field]) {
          student[field] = std[field];
        }
        if(field == "level_id" && std["level"]){
          student["level"] = std["level"];
        }
      });
      return student;
    });
  }

  getStudentsList = () => {
    const {school_id, scholar_year_id, students} = this.state;
    let order_students_by_ = this.school ? this.school.order_students_by : this.user.profile.schools.map(s => s.order_students_by).filter(osb => osb)[0] || "";
      
    if(school_id){
      var data={
          action: "get_natif_students",
          // page: 1,
          // page_size: 50,
          school_id: school_id,
          scholar_year_id: scholar_year_id
      }
      // if(this.is_sanady_view){
      //   data.get_students_witout_levels = 'true';
      // }
      // if(window.return_queries){
      //   data.return_queries = "true"
      // }
      // if(order_students_by_){
      //   data.order_students_by = order_students_by_;
      // }
      schoolStudents2(data).then(res=> {
          this.setStudents(Object.values(res.students));
      });
    }else{
      let data = {
        action: 'get_natif_students'
      }
      if(order_students_by_){
        data.order_students_by = order_students_by_;
      }
      profStudents(data).then(res=> {
          this.setStudents(res.students.map(student=> {
              if(student.school_user){
                student.first_name = student.school_user.first_name;
                student.last_name = student.school_user.last_name;
              }
              return student;
          }));
      });
    }
  }

  setStudents(res_students){
    var {students} = this.state;
    var parents = [];
    res_students.forEach((student) =>{
        if(student.parent && student.parent.username != this.user.username)
            if(parents.filter(parent => parent.username == student.parent.username).length == 0 && student.parent){
                student.parent.classe = student.classe;
                parents.push(student.parent);
            }
        if(student.parent2 && student.parent2.username != this.user.username)
            if(parents.filter(parent => parent.username == student.parent2.username).length == 0 && student.parent2){
                student.parent2.classe = student.classe
                parents.push(student.parent2);    
            }
    });
    this.setState({
      students: res_students,
      parents: parents
    })
  }
  refreshClassesAfterImport = () => {
    if(this.is_sanady_view){
      // this.getClassesList();
      let all_projects = get_projects_from_pogram({}, true, this.state.programs_projects_schools_by_years[this.state.scholar_year_id] || {})
      let all_schools = [];
      all_projects.map(pr => {
        all_schools = all_schools.concat(pr.schools || []);
      });
      this.all_schools_ids = all_schools.map(s => s.id);
      if(this.all_schools_ids && this.all_schools_ids.length > 0 && this.state.scholar_year_id){
        this.getProgramsProjectsSchoolsClasses(this.all_schools_ids, this.state.scholar_year_id);
      }
    }
  }
  unshiftStudent = (student) => {
    var {students, parents} = this.state;
    if(student.parent && student.parent.username != this.user.username)
      if(parents.filter(parent => parent.username == student.parent.username).length == 0 && student.parent){
          student.parent.classe = student.classe;
          parents.push(student.parent);
      }
    if(student.parent2 && student.parent2.username != this.user.username)
      if(parents.filter(parent => parent.username == student.parent2.username).length == 0 && student.parent2){
          student.parent2.classe = student.classe
          parents.push(student.parent2);    
      }
    students.unshift(student);
    this.setState({
      students: students,
      parents: parents
    });
  }
  refreshMissingStudents = (missing_student, student) => {
    var {students, missing_students} = this.state;
    missing_students = missing_students.map(ms => {
      if(ms.id == missing_student.id){
        return missing_student;
      }
      return ms;
    })
    if(student){
      students.unshift(student);
    }
    this.setState({
      students: students,
      missing_students: missing_students,
    });
  }
  refreshAllSchoolFieldsExport = (school_fields_export) => {
    var {school_all_fields_export} = this.state;
    if(!school_all_fields_export[school_fields_export.data_type]){
      school_all_fields_export[school_fields_export.data_type] = {};
    }
    if(!school_all_fields_export[school_fields_export.data_type][school_fields_export.list_type]){
      school_all_fields_export[school_fields_export.data_type][school_fields_export.list_type] = {};
    }
    school_all_fields_export[school_fields_export.data_type][school_fields_export.list_type][school_fields_export.export_type] = school_fields_export;
    this.setState({
      school_all_fields_export: school_all_fields_export,
    });
  }
  refreshAllPredefinedSchoolFieldsExport = (school_fields_export) => {
    var {school_predefined_fields_export} = this.state;
    if(!school_predefined_fields_export[school_fields_export.data_type]){
      school_predefined_fields_export[school_fields_export.data_type] = {};
    }
    if(!school_predefined_fields_export[school_fields_export.data_type][school_fields_export.id]){
      school_predefined_fields_export[school_fields_export.data_type][school_fields_export.id] = {};
    }
    school_predefined_fields_export[school_fields_export.data_type][school_fields_export.id] = school_fields_export;
    this.setState({
      school_predefined_fields_export: school_predefined_fields_export,
    });
  }
  refreshAllSchoolTextbookSubjectsExport = (school_textbook_subjects_export) => {
    var {school_all_subjects_export} = this.state;
    if(!school_all_subjects_export[school_textbook_subjects_export.data_type]){
      school_all_subjects_export[school_textbook_subjects_export.data_type] = {};
    }
    school_all_subjects_export[school_textbook_subjects_export.data_type] = school_textbook_subjects_export;
    this.setState({
      school_all_subjects_export: school_all_subjects_export,
    });
  }
  unshiftProfessor = (professor) => {
    var {professors} = this.state;
    professors.unshift(professor);
    if(!professor.image && professor.image_url){
      professor.image = professor.image_url;
    }
    this.setState({
      professors: professors,
    });
  }
  updateStudentsTransportCircuit = (added_usernames, removed_usernames, circuit) => {
    var {students} = this.state;
    students = students.map(std => {
      if(added_usernames.indexOf(std.username) != -1){
        if(std.transport_circuit_ids.indexOf(circuit.id) == -1){
          std.transport_circuit_ids.push(circuit.id);
          std.transport_circuits.push(circuit);
        }
      }
      else if(removed_usernames.indexOf(std.username) != -1){
        std.transport_circuit_ids = std.transport_circuit_ids.filter(tci => tci != circuit.id);
        std.transport_circuits = std.transport_circuit_ids.filter(tc => tc.id != circuit.id);
      }
      return std;
    });
    this.setState({
      students: students
    });
  }

  handleViewAbsNotification = (viewed_absences_notifications) => {
    var data = {
      "action": "view_absences_notifications_count",
      "school_id": this.state.school_id,
      "viewed_absences_notifications": viewed_absences_notifications,
    };
    absences_post_api(data).then(res => {
      this.setState({
        absences_notifications_ids: this.state.absences_notifications_ids.filter(ani => viewed_absences_notifications.indexOf(ani) === -1),
      });
    });
  };
  handleDocumentRequestTraited = (dr_id, is_traited) => {
    var documents_requests_not_dones_ids = this.state.documents_requests_not_dones_ids;
    if(is_traited){
      documents_requests_not_dones_ids = documents_requests_not_dones_ids.filter(dri => dri != dr_id);
    }
    else{
      if(documents_requests_not_dones_ids.indexOf(dr_id) == -1){
        documents_requests_not_dones_ids.push(dr_id);
      }
    }
    this.setState({
      documents_requests_not_dones_ids: documents_requests_not_dones_ids,
    });
  };
  handleAuthorisationValidated = (dr_id, is_done) => {
    var exit_authorisations_not_dones_ids = this.state.exit_authorisations_not_dones_ids;
    if(is_done){
      exit_authorisations_not_dones_ids = exit_authorisations_not_dones_ids.filter(dri => dri != dr_id);
    }
    else{
      if(exit_authorisations_not_dones_ids.indexOf(dr_id) == -1){
        exit_authorisations_not_dones_ids.push(dr_id);
      }
    }
    this.setState({
      exit_authorisations_not_dones_ids: exit_authorisations_not_dones_ids,
    });
  };
  handleViewIncidentNotification = (viewed_incidents_notifications) => {
    // var data = {
    //   "action": "view_incidents_notifications",
    //   "school_id": this.state.school_id,
    //   "scholar_year": this.state.scholar_year_id,
    //   "viewed_incidents_notifications": viewed_incidents_notifications,
    // };
    // behaviours_list_api_post(data).then(res => {
    //   this.setState({
    //     incidents_notifications_ids: this.state.incidents_notifications_ids.filter(ani => viewed_incidents_notifications.indexOf(ani) === -1),
    //   });
    // });
    var new_incidents_notifications_ids = this.state.incidents_notifications_ids.filter(ani => viewed_incidents_notifications.indexOf(ani) === -1);
    this.setState({
      incidents_notifications_ids: new_incidents_notifications_ids,
      students_notifications_ids: this.state.rdv_reports_notifications_ids.concat(new_incidents_notifications_ids).unique_item(),
    });
  };
  handleViewLeadsNotification = (viewed_leads_notifications) => {
    var new_leads_notifications_ids = this.state.leads_notifications_ids.filter(ani => viewed_leads_notifications.indexOf(ani) === -1);
    this.setState({
      leads_notifications_ids: new_leads_notifications_ids,
    });
  };
  handleViewRdvReportNotification = (viewed_rdv_reports_notifications) => {
    // var data = {
    //   "action": "view_rdv_reports_notifications",
    //   "school_id": this.state.school_id,
    //   "scholar_year": this.state.scholar_year_id,
    //   "viewed_rdv_reports_notifications": viewed_rdv_reports_notifications,
    // };
    // reports_list_api_post(data).then(res => {
    //   this.setState({
    //     rdv_reports_notifications_ids: this.state.rdv_reports_notifications_ids.filter(ani => viewed_rdv_reports_notifications.indexOf(ani) === -1),
    //   });
    // });
    var new_rdv_reports_notifications_ids = this.state.rdv_reports_notifications_ids.filter(ani => viewed_rdv_reports_notifications.indexOf(ani) === -1);
    this.setState({
      rdv_reports_notifications_ids: new_rdv_reports_notifications_ids,
      students_notifications_ids: this.state.incidents_notifications_ids.concat(new_rdv_reports_notifications_ids).unique_item(),
    });
  };
  getAbsentProfessorsTodayIdsList = () => {
    const {school_id, scholar_year_id} = this.state;
    if(school_id){
        var data={
            "action": "get_absent_professors_today_ids",
            "page":1,
            "page_size":20,
            "school_id": school_id,
            "scholar_year": scholar_year_id
        }
        school_professors_list_api(data).then(res => {
          this.setState({
            absent_professors_today_ids: res.absent_professors_today_ids
          })
        });
    }
  };
  getNewRegisteredProfessorsIdsList = () => {
    const {school_id, scholar_year_id} = this.state;
    if(school_id){
        var data={
            "action": "get_new_registred_professors_ids",
            "page":1,
            "page_size":20,
            "school_id": school_id,
            "scholar_year": scholar_year_id
        }
        school_professors_list_api(data).then(res => {
          this.setState({
            new_registred_professors_ids: res.new_registred_professors_ids || []
          })
        });
    }
  };

  getNotifValidMail = () => {
    var data = {
      action: "get_notif_validated_messages",
      group_id: this.school.group_id 
    }

    school_mailings_api_list(data).then(res => {
      this.setState({
        valid_messages_notif_ids: res.messages_notif_ids
      })
    })
  }
  getNotifValidEmail = () => {
    var data = {
      action: "get_notif_validated_emails",
      group_id: this.school.group_id 
    }

    school_email_api_list(data).then(res => {
      this.setState({
        valid_emails_notif_ids: res.emails_notif_ids
      })
    })
  }

  getNotifEmail = () => {
    var data = {
      action: "get_notif_emails"
    }

    school_email_api_list(data).then(res => {
      this.setState({
        emails_notif_ids: res.emails_notif_ids
      })
    })
  }

  getNotifMail = () => {
    var data = {
      action: "get_notif_messages"
    }

    school_mailings_api_list(data).then(res => {
      this.setState({
        messages_notif_ids: res.messages_notif_ids
      })
    })
  }

  messagesViewed = () => {
    var data = {
      action: "set_notif_messages_viewed"
    }

    school_mailings_api_store(data)
  }
  emailsViewed = () => {
    var data = {
      action: "set_notif_emails_viewed"
    }

    school_email_api_store(data)
  }

  validMessagesViewed = () => {
    var data = {
      action: "set_notif_validated_messages",
      mails_ids: this.state.valid_messages_notif_ids
    }

    school_mailings_api_store(data)
  }
  validEmailsViewed = () => {
    var data = {
      action: "set_notif_validated_emails",
      emails_ids: this.state.valid_emails_notif_ids
    }

    school_email_api_store(data)
  }

  removeProfessorAbsenceNotif = (professor_id) => {
    var {school_id, scholar_year_id, absent_professors_today_ids} = this.state;
    var length_absent_professors_today_ids = absent_professors_today_ids.length;
    absent_professors_today_ids = absent_professors_today_ids.filter(api => api != professor_id);
    if(length_absent_professors_today_ids != absent_professors_today_ids.length){
      this.setState({absent_professors_today_ids: absent_professors_today_ids});
      if(school_id){
          var data={
              "action": "set_professor_absence_notif_viewed",
              "school_id": school_id,
              "scholar_year": scholar_year_id,
              "school_professor_id": professor_id,
          }
          school_professors_list_api(data).then(res => {
          });
      }
    }
  };
  absentProfessorsViewed = () => {
    const {school_id, scholar_year_id} = this.state;
    if(school_id){
        var data={
            "action": "absent_professors_notif_viewed",
            "page":1,
            "page_size":20,
            "school_id": school_id,
            "scholar_year": scholar_year_id
        }
        school_professors_list_api(data).then(res => {
        });
    }
  };

  update_professors = () => {
    if(true || (this.state.classes.length > 0 || this.state.activities_classes.length > 0) && this.state.professors.length > 0){
      let schools_ = [];
      if(this.user.schools && this.user.schools.length > 0){
        schools_ = this.user.schools;
      }
      else if(this.user.profile.schools && this.user.profile.schools.length > 0){
        schools_ = this.user.profile.schools;
      }
      else if(this.user.profile.admin_schools && this.user.profile.admin_schools.length > 0){
        schools_ = this.user.profile.admin_schools;
      }
      this.setState({
        professors: this.state.professors.map(pr => {
          pr.children_students = (pr.children_students || []).map(cs => {
            cs.level = this.levels.filter(l => l.level_id == cs.level_id)[0];
            cs.classe = this.state.classes.filter(c => c.classe_id == cs.classe_id)[0];
            cs.school = schools_.filter(s => s.id == cs.school_id).map(s => {
              return {
                id: s.id,
                name: s.name
              }
            })[0];
            return cs;
          });
          pr.classes = pr.classes.map(classe_id => {
            let cl = this.state.classes.find(c => c.classe_id == classe_id);
            if(cl)
              return {
                classe_id: classe_id,
                name: cl.name,
                level: {
                  level_id: cl.level.level_id,
                  name: cl.level.name
                }
              }
            else
              return classe_id
          });

          pr.activities_classes = pr.activities_classes.map(id => {
            let cl = this.state.activities_classes.find(c => c.id == id);
            if(cl)
              return {
                id: id,
                name: cl.name
              }
            else
              return id
          });
          
          if(this.get_local_levels().length > 0){
            pr.levels = pr.levels.filter(lvl_id => this.get_local_levels().findIndex(l => l.level_id == lvl_id) >= 0).map(lvl_id => {
              let lvl = this.get_local_levels().find(l => l.level_id == lvl_id)
              return {
                name: lvl.name,
                level_id: lvl.level_id,
                group_id: lvl.group_id,
                subjects: lvl.subjects.map(s => ({
                  subject_id: s.subject_id,
                  name: s.name
                }))
              }
            })
            pr.subjects = pr.subjects.map(sub_id => {
              let curr_lvl = pr.levels.find(lvl => lvl.subjects.findIndex(s => s.subject_id == sub_id) >= 0),
                sub = curr_lvl?curr_lvl.subjects.find(s => s.subject_id == sub_id):false;
              if(sub)
                return {
                  subject_id: sub.subject_id,
                  name: sub.name
                }
              else return sub_id
            })
          }


          if(!pr.image && pr.image_url){
            pr.image = pr.image_url;
          }

          return pr;
        })
      })
    }
  }



  sync_professors = (existing_classes_levels_ids) => {
    if(!this.school)return;
    check_group_last_update({group_id: this.school.group_id}).then(res => {
      if(res.professors_last_update !== this.professors_last_update){
        this.professors_last_update = res.professors_last_update
        this.getProfessorsList(existing_classes_levels_ids)
      }
      if (res.schools_documents_creation_requests_last_update !== this.schools_documents_requests_last_update || res.schools_documents_requests_last_update !== this.schools_documents_requests_update_last_update) {
        this.schools_documents_requests_last_update = res.schools_documents_creation_requests_last_update;
        this.schools_documents_requests_update_last_update = res.schools_documents_requests_last_update;
        this.getSchoolDocumentsRequestsNotifs();
        this.setState(prevState => ({
          documentsRequestsRefreshKey: prevState.documentsRequestsRefreshKey + 1
        }));
      }
    })
  }

  getProfessorsList = (existing_classes_levels_ids) => {
    existing_classes_levels_ids = existing_classes_levels_ids || this.existing_classes_levels_ids || {};
    const {school_id, scholar_year_id, professors} = this.state;
    if(this.school){
        let permission = new Permission();
        var data = {
          action: "get_natif_professors",
          school_id: this.school.id,
          scholar_year_id: scholar_year_id,
          get_children_students: true,
          level_ids: this.can_update_level_classe_for_all_cycles || permission.can("update_level_classe_for_all_cycles", "professors") ? this.school_levels_for_assistant.map(l => "'" + l.level_id + "'").join(',') : this.levels.filter(l => !permission.hasSection('cycle_' + l.group_id) || permission.hasLevel('cycle_' + l.group_id, 'level_' + l.level_id)).map(l => "'" + l.level_id + "'").join(',')
        }
        
        school_professors_list_api2(data).then(res => {
          var levels_ids_ = this.levels.filter(l => !permission.hasSection('cycle_' + l.group_id) || permission.hasLevel('cycle_' + l.group_id, 'level_' + l.level_id)).map(l => l.level_id);
          let school_professors_ids = [];
          this.setState({
            professors: res.professors.map(pr => {
              school_professors_ids.push(pr.school_professor_relationship_id || pr.id);
              if(this.school && this.user.profile.is_assistant && (this.can_update_level_classe_for_all_cycles || permission.can("update_level_classe_for_all_cycles", "professors"))){
                if(levels_ids_.some(item => pr.levels.includes(item))){

                }
                else{
                  pr.edit_only_level_classe = true;
                }
              }
              return pr;
            })
          }, () => {
            this.update_professors();
            if(this.school && this.can_update_level_classe_for_all_cycles || permission.can("update_level_classe_for_all_cycles", "professors")){
              var pat = /^https?:\/\//i;
              var data_ = {
                action: "get_classes",
                school_id: school_id,
                scholar_year: scholar_year_id,
                levels_ids_to_exclude: existing_classes_levels_ids,
              };
              school_classes_store_api(data_).then(res => {
                this.setState({
                  assistant_other_classes: res.classes.map(c => {
                    c.full_image_url = (pat.test(c.full_image_url) || !c.full_image_url)?c.full_image_url:base_url + "/" +  c.full_image_url;
                    return c;
                  })
                });
              });
            }
            if(this.school.project_id){
              let data_ = {
                school_id: school_id,
                action: "get_professors_active_periods",
                scholar_year: scholar_year_id,
                school_professors_ids: school_professors_ids.join(",")
              };
              sanady_professors_api(data_).then((res) => {
                if (res.success){
                  this.professors_active_periods = res.professors_active_periods || {};
                  this.setState({
                    professors: this.state.professors.map(pr_ => {
                      let pr = {...pr_};
                      pr.active_periods = this.professors_active_periods[pr.school_professor_relationship_id || pr.id] || [];
                      window.moment_ = moment;
                      let active_period = pr.active_periods.filter(ap => ap.date_entree && moment(ap.date_entree).isSameOrBefore(moment()) && ap.date_sortie && moment().isSameOrBefore(moment(ap.date_sortie)))[0];
                      if(active_period){
                        pr.is_active = true;
                      }
                      return pr;
                    }),
                  });
                }
              });
            }
          })
        });
    }
    else{
        var data={
            action: "get_professors_contacts_list",
            include_all: 1
        }
        professor_professors_list_api(data).then(res => {
          this.setState({
            professors: (res.professors || []).map(pr => {
              if(!pr.image && pr.image_url){
                pr.image = pr.image_url;
              }
              return pr;
            })
          })
        });
    }
  };

  getJournals = ()=>{
    const {school_id, scholar_year_id, professors} = this.state;
    var user = get('session_user')
    if(!school_id){
      var data1 = {
        action: "get_journals",
        /*page_size: PAGE_SIZE,
        page: 1*/
        day_week: moment().startOf("week").add(3, "days").format("YYYY-MM-DD"),
      };
      instance
      .get(`/journal_handler`, {
        headers: {
          Authorization: "Bearer " + user.token
        },
        params: data1
      })
      .then(response => {
        this.setState({
          data_loaded:true,
          seances:response.data.journals.concat([] || response.data.sanc_jou).concat(response.data.deleted_jouranl),
        })
      
      }).catch(err => console.log("error", err));
    }
  }

  handleSwitchMenuGlobal = () => {
    this.setState({
      menuGlobal: !this.state.menuGlobal
    })
  }

  refreshStudentsToChangeLevels = () => {

    const {school_id, scholar_year_id} = this.state;
    if(school_id){
      var data = {};
      data.school_id = school_id;
      data.scholar_year = scholar_year_id;
      data.action = "get_natif_students_to_change_levels";
      data.only_ids = "true";
      schoolStudents(data).then(res => {
        this.setState({
          students_to_change_levels_ids: res.students_to_change_levels_ids || []
        })
      });
    }
  }
  refreshStudentsMissings = () => {

    const {school_id, scholar_year_id} = this.state;
    if(school_id){
      var data = {};
      data.school_id = school_id;
      data.scholar_year_id = scholar_year_id;
      data.action = "get_natif_missing_students";
      missing_students_api_get(data).then(res => {
        this.setState({
          missing_students: res.missing_students || []
        })
      });
    }
  }

  render() {
    const { Layout, Component } = this.props;
    if(this.props.path == "/school/list" || this.props.path == "/school/program/list"){
      return <Component {...this.props} correctStudentsInfo={this.correctStudentsInfo}/>
    }
    else{
      let permission = new Permission();
      this.professors_ = [].concat(this.state.professors);
      if(this.school && this.user.profile.is_assistant && !(this.props.pagetype == "professors" && (this.can_update_level_classe_for_all_cycles || permission.can("update_level_classe_for_all_cycles", "professors")))){
        var levels_ids = this.levels.filter(l => !permission.hasSection('cycle_' + l.group_id) || permission.hasLevel('cycle_' + l.group_id, 'level_' + l.level_id)).map(l => l.level_id);
        this.professors_ = [].concat(this.state.professors.filter(pr => {
          return levels_ids.some(item => pr.levels.map(l => l.level_id || l).includes(item));
        }));
      }
      return (
        <Layout 
          handleSwitchMenuGlobal={this.handleSwitchMenuGlobal}
          menuGlobal={this.state.menuGlobal}
          ws={this.ws}
        >
          <Component
            {...this.props}
            // extra_props={this.state.extra_props}
            global_data={{...this.state, professors: this.professors_}}
            documentsRequestsRefreshKey={this.state.documentsRequestsRefreshKey}
            unshiftProfessor={this.unshiftProfessor}
            updateStudentsExemptionsFromSubjects={this.updateStudentsExemptionsFromSubjects}
            getStudentsExemptionsFromSubjects={this.getStudentsExemptionsFromSubjects}
            handleUpdateProfessor={pr => {
              this.setState({
                professors : this.state.professors.map(p => {
                  if(p.id == pr.id)
                    return pr;
                  return p;
                })
              })
            }}
            mark_school_notification_as_read={this.mark_school_notification_as_read}
            refreshClassesAfterImport={this.refreshClassesAfterImport}
            unshiftStudent={this.unshiftStudent}
            correctStudentsInfo={this.correctStudentsInfo}
            refreshMissingStudents={this.refreshMissingStudents}
            refreshAllSchoolFieldsExport={this.refreshAllSchoolFieldsExport}
            refreshAllPredefinedSchoolFieldsExport={this.refreshAllPredefinedSchoolFieldsExport}
            refreshAllSchoolTextbookSubjectsExport={this.refreshAllSchoolTextbookSubjectsExport}
            refreshGlobalProfessors={this.refreshGlobalProfessors}
            handleViewAbsNotification={this.handleViewAbsNotification}
            handleViewIncidentNotification={this.handleViewIncidentNotification}
            handleDocumentRequestTraited={this.handleDocumentRequestTraited}
            handleAuthorisationValidated={this.handleAuthorisationValidated}
            handleViewLeadsNotification={this.handleViewLeadsNotification}
            handleViewRdvReportNotification={this.handleViewRdvReportNotification}
            refreshAbsentProfessorsTodayIds={this.getAbsentProfessorsTodayIdsList}
            refreshNewProfessorsIds={this.getNewRegisteredProfessorsIdsList}
            removeProfessorAbsenceNotif={this.removeProfessorAbsenceNotif}
            refreshProfessorsList={this.getProfessorsList}
            getClassesList={this.getClassesList}
            refreshStudentsList={this.getStudentsList}
            absentProfessorsTodayNotifViewed={() => {
              if(this.state.absent_professors_today_ids.length){
                this.absentProfessorsViewed();
                setTimeout(() => {
                  this.setState({absent_professors_today_ids: []});
                }, 100);
              }
            }}
            newRegistrationProfessorsViewed={(viewed_id, school_professor) => {
              var {professors} = this.state;
              if(this.state.new_registred_professors_ids.length){
                setTimeout(() => {
                  if(school_professor && school_professor.to_validate_updates){
                    professors = professors.map(pr => {
                      if(school_professor.school_professor_relationship_id == pr.school_professor_relationship_id){
                        if((school_professor.teaching_seniority_to_validate || school_professor.teaching_seniority_to_validate === 0) && school_professor.teaching_seniority_to_validate != school_professor.teaching_seniority){
                          pr.teaching_seniority = school_professor.teaching_seniority_to_validate;
                        }
                        if((school_professor.rib_to_validate) && school_professor.rib_to_validate != school_professor.rib){
                          pr.rib = school_professor.rib_to_validate;
                        }
                      }
                      return pr;
                    });
                  }
                  else if(school_professor){
                    professors.unshift(school_professor);
                  }
                  this.setState({
                    new_registred_professors_ids: this.state.new_registred_professors_ids.filter(nri => nri != viewed_id),
                    professors: professors,
                  });
                }, 100);
              }
            }}
            refreshStudentsToChangeLevels={() => {
              this.refreshStudentsToChangeLevels()
            }}
            messagesViewed={() => {
              if(this.state.messages_notif_ids.length > 0){
                this.messagesViewed();
                this.setState({messages_notif_ids: []});
              }
            }}
            validMessagesViewed={() => {
              
              if(this.state.valid_messages_notif_ids.length > 0){
                this.validMessagesViewed();
                this.setState({valid_messages_notif_ids: []});
              }
            }}
            emailsViewed={() => {
              // if(this.state.emails_notif_ids.length > 0){
              //   this.emailsViewed();
              //   this.setState({emails_notif_ids: []});
              // }
            }}
            validEmailsViewed={() => {
              
              // if(this.state.valid_emails_notif_ids.length > 0){
              //   this.validEmailsViewed();
              //   this.setState({valid_emails_notif_ids: []});
              // }
            }}
            updateStudentsTransportCircuit={this.updateStudentsTransportCircuit}
            handleSetClasses={(classes) => this.setState({classes:classes})} 
            handleSetActivitiesClasses={(activities_classes) => this.setState({activities_classes:activities_classes})} 
            refreshVehiculesNeedOilChangeCount={() => this.getVehiculesNeedOilChangeCount()} 
            ws={this.ws}
          />
        </Layout>
      );
    }
  }
};

const mapState2Props = state => ({ session: state.session });
export default withRouter(connect(mapState2Props)(LayoutSchoolSystem));
